module.exports = __webpack_public_path__ + "img/img_20years_2.a95b4956.jpg";